module.exports = __webpack_public_path__ + "img/special_1.fb341833.png";